// extracted by mini-css-extract-plugin
export var desktop250 = "publift-ad-module--desktop-250--83b5d";
export var desktop280 = "publift-ad-module--desktop-280--f60c2";
export var desktop600 = "publift-ad-module--desktop-600--7f3b5";
export var desktop90 = "publift-ad-module--desktop-90--a0802";
export var mobile100 = "publift-ad-module--mobile-100--14b5e";
export var mobile280 = "publift-ad-module--mobile-280--05a47";
export var publiftAd = "publift-ad-module--publift-ad--87d76";